import TinyMCEEditor from "components/UI/HTMLEditor/TinyMCEEditor";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { USER_GUIDE_TEXT } from "./UserGuide";
import { QUERY_KEYS } from "constant/react_query";
import { useUnosEditableTextGet } from "hooks/unos/editable_text/useUnosEditableTextGet";
import { useUnosEditableTextAdd } from "hooks/unos/editable_text/useUnosEditableTextAdd";
import { useUnosEditableTextUpdate } from "hooks/unos/editable_text/useUnosEditableTextUpdate";

type UserGuideEditProps = {
  cancelHandle: Function;
};

const UserGuideEdit = ({ cancelHandle }: UserGuideEditProps) => {
  const editableText = useUnosEditableTextGet(USER_GUIDE_TEXT);
  const { editableTextAddMutate } = useUnosEditableTextAdd({
    invalidateKeys: [QUERY_KEYS.UNOS_EDITABLE_TEXT_GET, editableText.slug],
  });
  const { editableTextUpdateMutate } = useUnosEditableTextUpdate({
    invalidateKeys: [QUERY_KEYS.UNOS_EDITABLE_TEXT_GET],
  });

  const editorContentConfirm = (content: string) => {
    if (typeof editableText !== "undefined" && editableText !== null) {
      editableTextUpdateMutate({
        id: editableText.id,
        updatePayload: { content },
      });
    } else {
      editableTextAddMutate({ slug: USER_GUIDE_TEXT, content });
    }
    toast.success("Saved");
  };

  return (
    <div>
      <TinyMCEEditor
        onContentConfirm={editorContentConfirm}
        onCancel={cancelHandle}
        initialValue={editableText !== null ? editableText.content : ""}
      />
    </div>
  );
};

export default UserGuideEdit;
